import React from "react";
import "react-vertical-timeline-component/style.min.css";
import "./style.css";
import { motion } from "framer-motion";
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { useMediaQuery } from 'react-responsive';

import HospedagemSection from "./airbnb";

import ouropretoImage from "../../assets/images/pages/op.jpg";
import opGallery1 from "../../assets/images/pages/op1.jpg";
import opGallery2 from "../../assets/images/pages/op2.jpg";
import opGallery3 from "../../assets/images/pages/op3.jpg";
import opGallery4 from "../../assets/images/pages/op4.jpg";
import opGallery5 from "../../assets/images/pages/op5.jpg";
import opGallery6 from "../../assets/images/pages/op6.jpg";
import opGallery1thumb from "../../assets/images/pages/op1thumb.jpg";
import opGallery2thumb from "../../assets/images/pages/op2thumb.jpg";
import opGallery3thumb from "../../assets/images/pages/op3thumb.jpg";
import opGallery4thumb from "../../assets/images/pages/op4thumb.jpg";
import opGallery5thumb from "../../assets/images/pages/op5thumb.jpg";
import opGallery6thumb from "../../assets/images/pages/op6thumb.jpg";

import Header from "../../components/header";
import Header2 from "../../components/header2";
import Footer from "../../components/footer";

const images = [
    {
        original: opGallery1,
        thumbnail: opGallery1thumb,
    },
    {
        original: opGallery2,
        thumbnail: opGallery2thumb,
    },
    {
        original: opGallery3,
        thumbnail: opGallery3thumb,
    },
    {
        original: opGallery4,
        thumbnail: opGallery4thumb,
    },
    {
        original: opGallery5,
        thumbnail: opGallery5thumb,
    },
    {
        original: opGallery6,
        thumbnail: opGallery6thumb,
    }
];

const OuroPretoPage = () => {

    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    return (
        //Background
        <div className="bg-white text-gray-900">
            {/* Header */}

            <Header2 />
            <Header />
            <div className="bg-space" />

            {/* 1ª Seção - Imagem de Ouro Preto e chamada */}
            {!isMobile && (
                <div className="ouropreto-hero" style={{ backgroundImage: `url(${ouropretoImage})` }}>
                    <div className="overlay" />
                    <motion.div
                        className="hero-content"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}>

                        <motion.h1
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}>
                            Ouro Preto
                        </motion.h1>

                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.3 }}>
                            A cidade que respira história, cultura e tradição.
                        </motion.p>
                    </motion.div>
                </div>
            )}
            {isMobile && (
                <div className="ouropreto-hero-mobile" style={{ backgroundImage: `url(${ouropretoImage})` }}>
                    <div className="overlay" />
                    <motion.div
                        className="hero-content"
                        initial={{ opacity: 0, y: 50 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, ease: "easeOut" }}>

                        <motion.h1
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}>
                            Ouro Preto
                        </motion.h1>

                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.3 }}>
                            A cidade que respira história, cultura e tradição.
                        </motion.p>
                    </motion.div>
                </div>
            )}


            {/* 2ª Seção - Texto e Galeria de Imagens */}
            {!isMobile && (
                < div className="row">
                    {/* Texto */}
                    <div className="col spaceSection2">
                        <motion.div
                            className="px-2 md:px-4"
                            initial={{ opacity: 0, x: -30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6 }}
                            viewport={{ once: true }}>

                            <p className="mb-4">
                                Reconhecida pela UNESCO como Patrimônio Cultural da Humanidade, Ouro Preto é uma cidade que preserva, em cada rua de pedra e ladeira íngreme, um capítulo importante da história do Brasil. Caminhar por suas vias é como visitar um museu a céu aberto, onde o passado colonial se faz presente por meio de igrejas monumentais, casarões seculares e obras-primas da arte barroca.
                            </p>
                            <p className="mb-4">
                                A riqueza arquitetônica e artística de Ouro Preto é marcada por esculturas e construções que expressam o auge da Arte Barroca Mineira, representada por nomes como Aleijadinho e Mestre Ataíde. Igrejas ricamente ornamentadas, museus históricos e espaços culturais espalham-se por toda a cidade, atraindo visitantes que buscam mergulhar no patrimônio cultural brasileiro.
                            </p>
                            <p>
                                Cercada por montanhas e paisagens naturais de tirar o fôlego, Ouro Preto também encanta pela sua geografia. Mirantes e trilhas revelam vistas deslumbrantes e conectam os visitantes à natureza exuberante da região. O Pico do Itacolomi, com 1.772 metros de altitude, é um dos pontos mais emblemáticos para quem deseja contemplar a cidade de cima.
                            </p>
                        </motion.div>
                    </div>

                    {/* Galeria de Imagens */}
                    <div className="col spaceSection2">
                        <motion.div
                            className="px-2 md:px-4"
                            initial={{ opacity: 0, x: 30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6 }}
                            viewport={{ once: true }}>

                            <div className="max-w-5xl mx-auto py-10">
                                <ImageGallery
                                    items={images}
                                    showPlayButton={false}
                                    showNav={false}
                                    showBullets={true}
                                    showFullscreenButton={true}
                                    showThumbnails={true}
                                    thumbnailPosition="bottom"
                                    autoPlay={true}
                                    slideDuration={750}
                                />
                            </div>

                        </motion.div>
                    </div>
                </div>
            )}
            {isMobile && (
                <div className="spaceSection3 flex flex-col lg:flex-row px-4 md:px-8 lg:px-20 py-16 gap-12 items-start bg-white">
                    {/* Texto */}
                    <div className="lg:w-1/2 space-y-6">
                        <motion.div
                            initial={{ opacity: 0, x: -30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6 }}
                            viewport={{ once: true }}
                        >
                            <p className="mb-4 text-justify leading-relaxed">
                                Reconhecida pela UNESCO como Patrimônio Cultural da Humanidade, Ouro Preto é uma cidade que preserva, em cada rua de pedra e ladeira íngreme, um capítulo importante da história do Brasil. Caminhar por suas vias é como visitar um museu a céu aberto, onde o passado colonial se faz presente por meio de igrejas monumentais, casarões seculares e obras-primas da arte barroca.
                            </p>
                            <p className="mb-4 text-justify leading-relaxed">
                                A riqueza arquitetônica e artística de Ouro Preto é marcada por esculturas e construções que expressam o auge da Arte Barroca Mineira, representada por nomes como Aleijadinho e Mestre Ataíde. Igrejas ricamente ornamentadas, museus históricos e espaços culturais espalham-se por toda a cidade, atraindo visitantes que buscam mergulhar no patrimônio cultural brasileiro.
                            </p>
                            <p className="text-justify leading-relaxed">
                                Cercada por montanhas e paisagens naturais de tirar o fôlego, Ouro Preto também encanta pela sua geografia. Mirantes e trilhas revelam vistas deslumbrantes e conectam os visitantes à natureza exuberante da região. O Pico do Itacolomi, com 1.772 metros de altitude, é um dos pontos mais emblemáticos para quem deseja contemplar a cidade de cima.
                            </p>
                        </motion.div>
                    </div>

                    {/* Galeria */}
                    <div className="lg:w-1/2">
                        <motion.div
                            initial={{ opacity: 0, x: 30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.6 }}
                            viewport={{ once: true }}
                        >
                            <div className="w-full rounded-xl overflow-hidden shadow-md border border-gray-200 bg-white">
                                <ImageGallery
                                    items={images}
                                    showPlayButton={false}
                                    showNav={false}
                                    showBullets={true}
                                    showFullscreenButton={true}
                                    showThumbnails={true}
                                    thumbnailPosition="bottom"
                                    autoPlay={true}
                                    slideDuration={750}
                                />
                            </div>
                        </motion.div>
                    </div>
                </div>
            )}

            <HospedagemSection />
            <Footer />
        </div >

    );
};

export default OuroPretoPage;
